import axios from 'axios'
// import fs from 'fs'
// import formData from 'form-data'
// import * as queries from './graphQLQueries.js'
// import { formatBytes } from './helpers.js'
// import AWS from 'aws-sdk'

const dfltDefaultSound = ''
const dfltLoop = true
const dfltVibration = false

const dfltClearValue = "ALL"
const dfltBackgroundColor = "#000000"
const dfltbackgroundImage = ''
const dfltHeaderImage = ''
const dfltQuestionImage = ''


//Kalliope v2 payload parsing
export function parsePayload(payload){
  let data = {}

  console.log("DEBUG libKaClient payload: ",payload)
  data.id = payload.actionId
  data.type = payload.type
  //Attributes
  
  payload.attributes.hasOwnProperty('loop') ? data.loop = payload.attributes.loop : data.loop = dfltLoop
  payload.attributes.sound ? data.defaultSound = payload.attributes.sound : data.defaultSound = dfltDefaultSound
  payload.attributes.vibration ? data.vibration = payload.attributes.vibration : data.vibration = dfltVibration
  //Last attribute is screenOrientation, but is not processed at this moment

  //Modifiers
  payload.modifiers.clear ? data.clear = payload.modifiers.clear : data.clear = dfltClearValue
  payload.modifiers.backgroundColor ? data.bgColorRemote = payload.modifiers.backgroundColor : data.bgColorRemote = dfltBackgroundColor
  payload.modifiers.backgroundImage ? data.backgroundImage = payload.modifiers.backgroundImage : data.backgroundImage = dfltbackgroundImage
  payload.modifiers.headerImage ? data.headerImage = payload.modifiers.headerImage : data.headerImage = dfltHeaderImage
  payload.modifiers.questionImage ? data.questionImage = payload.modifiers.questionImage : data.questionImage = dfltQuestionImage
  
  //data.filters = payload.filters
  //data.targetDevice = 'smartphone'
  
  switch (data.type){
    case 'video':
    case 'image':
    case 'audio':
      data.value = payload.url
      break
    default:
      data.value = payload.value
  }
  console.log("DEBUG libKaClient data: ",data)
  return data
}

// GRAPHQL QUERIES 

axios.defaults.headers.common['x-hasura-admin-secret'] = 'wvD@dcuUUdD5'

export async function getChannelbyId(baseURI,channelId){
	let response = {}
	let results = {}

	let {data: { data: { channel } } } = await axios.post(baseURI,{
		
		variables: {
			chId: channelId
		},
    query: `query getChannelsInfo($chId: Int!) {
              channel:channels_by_pk(id: $chId) {
                  id
                  name
                  icon_url
                  landing_page
                  languages {
                    id
                    language_value
                  }
                  mqtt_server
                  root_topic
                  promotional_video
                  screen_orientation
                  show_in_app
                  medias {
                    id
                    name
                    type
                    local
                    media_url
                  }
                  filters {
                    id
                    name
                    options {
                      id
                      order
                      topic
                      value
                    }
                    order
                    chainable
                    type
                  }
                }
            }`
    })

    return channel
	// console.log("getChannels resp",response)
	// let channels = response.data.data.customerChannels.channels

	// return channels
}
export async function getChannelbyName(baseURI,channelName){
  let {data: { data: { channel } } } = await axios.post(baseURI,{
      
    variables: {
      chName: channelName
    },
    query: `query getChannelbyName($chName: String!) {
              channel: channels( where: {name: {_ilike: $chName}}) {
                id
                name
                icon_url
                landing_page
                languages {
                  id
                  language_value
                }
                mqtt_server
                root_topic
                promotional_video
                screen_orientation
                show_in_app
                medias {
                  id
                  name
                  type
                  local
                  media_url
                }
                filters {
                  id
                  name
                  options {
                    id
                    order
                    topic
                    value
                  }
                  order
                  chainable
                  type
                }
              }
            }`
    })
   
    return channel
}